'use client';

export default function AudioIcon() {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke={"currentColor"}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    role="img"
    className="speaker-icon"
  >
    {/* Speaker body */}
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />

    {/* Sound waves */}
    <path d="M15 8a5 5 0 0 1 0 8" />
    <path d="M18 5a9 9 0 0 1 0 14" />
  </svg>
}